import { useTranslation } from "shared/localization/localization";
import { Button, Link } from "shared/ui/Button";
import { CloseIcon } from "shared/ui/Icons";
import { Portal } from "shared/ui/Portal";
import styles from "./OutOfCreditsModal.module.scss";

import { buyCreditsUrl } from "../model/outOfCredits.lib";
import { useCreditDenial } from "../model/useCreditDenial";

/**
 * Shown whenever the back office answers 402 `insufficient_credits`: following
 * one more shipment, or a paid tool call, costs more QCredits than are left.
 */
export const OutOfCreditsModal: RFC = () => {
  const { denial, dismiss } = useCreditDenial();
  const { t } = useTranslation();

  if (denial === null) {
    return null;
  }

  const title = t("Not enough QCredits");
  const text = t(
    "QCredits needed: {{needed}}. Your balance: {{balance}}. The shipments you already follow keep updating.",
    { needed: denial.needed, balance: denial.balance }
  );

  return (
    <Portal className={styles.modal} closePopup={dismiss}>
      <Button className={styles.closeBtn} onClick={dismiss} aria-label={t("Not now")}>
        <CloseIcon />
      </Button>
      <div className={styles.content} role="dialog" aria-modal="true" aria-label={title}>
        <p className={styles.title}>{title}</p>
        <p className={styles.text}>{text}</p>
        <div className={styles.buttons}>
          <Button className={styles.cancelButton} size="small" onClick={dismiss}>
            {t("Not now")}
          </Button>
          <Link
            className={styles.primaryButton}
            variant="primary"
            size="small"
            href={buyCreditsUrl(denial)}
            target="_blank"
            rel="noopener noreferrer"
            onClick={dismiss}
          >
            {t("Buy QCredits")}
          </Link>
        </div>
      </div>
    </Portal>
  );
};
